import { render } from "./Flight.vue?vue&type=template&id=3bca476e&scoped=true"
import script from "./Flight.vue?vue&type=script&lang=js"
export * from "./Flight.vue?vue&type=script&lang=js"

import "./Flight.vue?vue&type=style&index=0&id=3bca476e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bca476e"]])

export default __exports__